// @flow
import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { setNavigationColour as setNavigationColourFn } from "../../pages/MarketingLayout/Navigation/ducks";

const mapStateToProps = (state) => ({
  navigationColour: state.navigation.colour,
});

const mapDispatchToProps = (dispatch, props) => ({
  setNavigationColour: () => dispatch(setNavigationColourFn(props.colour)),
  clearNavigationColour: () => dispatch(setNavigationColourFn()),
});

const withNavColourHandler = (Component) =>
  class extends React.Component<Object, Object> {
    constructor(props) {
      super(props);
      this.setColour();
    }

    componentDidUpdate() {
      this.setColour();
    }

    setColour = () => {
      const { colour, navigationColour, setNavigationColour } = this.props;

      if (colour !== navigationColour) {
        setNavigationColour();
      }
    };

    render() {
      return <Component {...this.props} />;
    }
  };

export const withNavColour = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNavColourHandler,
);
